/* eslint-disable react/prop-types */
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import { useEffect, useRef, useState } from "react";
import { PaperComponent } from "../../utils/constants";

const PrintDangKySanPham = ({ data, open, onClose }) => {
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const toolBarRef = useRef(null);
  const [printContent, setPrintContent] = useState("");
  useEffect(() => {
    const date = new Date();
    if (data && data.id) {
      let body = `<p style="text-align:center;"><span><strong>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</strong></span></p>
<p style="text-align:center;"><span><strong><u>Độc lập – Tự do – Hạnh phúc</u></strong></span></p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p style="text-align:center;"><span><strong>PHIẾU ĐĂNG KÝ</strong></span></p>
<p style="text-align:center;"><span><strong>Tham gia đánh giá, phân hạng sản phẩm Chương trình OCOP của tỉnh Quảng Nam&nbsp;năm 2025</strong></span></p>
<ol>
  <li>
    <p><span>Thông tin về đơn vị&nbsp;đăng&nbsp;ký:</span></p>
    <p><span>- Tên đơn vị: ${data?.chuthe_ten}</span></p>
    <p><span>- Họ tên người đại diện pháp lý: ${
      data?.chuthe_nguoidaidienphapluat
    }</span></p>
    <p><span>- Chức vụ: ${
      data?.chuthe_nguoidaidienphapluat_chucvu
        ? data?.chuthe_nguoidaidienphapluat_chucvu
        : ""
    }</span></p>
    <p><span>- Địa chỉ liên hệ: ${
      data?.chuthe_nguoidaidienphapluat_diachi
        ? data?.chuthe_nguoidaidienphapluat_diachi
        : ""
    }</span></p>
    <p><span>- Điện thoại:&nbsp;&nbsp;&nbsp;${
      data?.chuthe_dienthoai ? data?.chuthe_dienthoai : ""
    }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Email: </span>${
        data?.chuthe_email ? data?.chuthe_email : ""
      }</span></p>
  </li>
  <li><p><span>Tên sản phẩm: ${data?.sanpham_ten}</span></p></li>
  <li><p><span>Nhóm sản phẩm đăng ký (Ngành, Nhóm, Phân nhóm1): ${
    data?.bosanpham_ten
  }, ${data?.phanloai_ten}, ${data?.nhomsanpham_ten}</span></p></li>
  <li><p><span>Lần đăng ký&nbsp;đánh&nbsp;giá: ${
    data?.landanhgia_ten
  }</span></p></li>
  <li>
    <p><span>Tài liệu kèm theo:</span></p>
    <p><span>- Báo cáo&nbsp;đánh&nbsp;giá về sản phẩm theo Bộ tiêu chí (bản gốc, bản điện tử).</span></p>
    <p><span>- Sản phẩm mẫu (số lượng):&nbsp;${data?.sanphammau}</span></p>
  </li>
</ol>
<p style="text-align:justify;"><span>Cam đoan những thông tin trong Phiếu đăng ký&nbsp;là&nbsp;đúng sự thật, chúng tôi xin cam kết tuân&nbsp;thủ&nbsp;các quy định của Chương trình OCOP về đánh giá, phân hạng sản&nbsp;phẩm&nbsp;OCOP, chịu trách nhiệm trước Hội đồng và pháp luật về Hồ sơ đăng ký đánh giá, phân hạng sản phẩm.</span></p>
<p>&nbsp;</p>
<figure class="table">
  <table>
    <tbody>
      <tr>
        <td>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</td>
        <td>
          <p><span>Quảng Nam, ngày ${date
            .getDate()
            .toString()
            .padStart(2, "0")} tháng ${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")} năm ${date.getFullYear()}</span></p>
          <p style="text-align:center;"><span><strong>ĐẠI DIỆN</strong></span></p>
          <p style="text-align:center;"><span>(<i>Ký, đóng dấu, ghi rõ họ tên</i>)</span></p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </td>
      </tr>
    </tbody>
  </table>
</figure>
<p>&nbsp;</p>
<p style="margin-left:0in;"><span style="color:black;font-family:'Times New Roman', Times, serif;">&nbsp;</span></p>
<p><br>&nbsp;</p>
<p>&nbsp;</p>
<p style="text-align:center;">
  <span><strong>PHẦN DÀNH CHO CƠ QUAN QUẢN LÝ</strong></span><br>
  <span><strong>DÀNH CHO CƠ QUAN QUẢN LÝ CHƯƠNG TRÌNH OCOP CẤP HUYỆN</strong></span>
</p>
<p><span>Phiếu số:….&nbsp;-&nbsp;……./PĐK-${data?.matinh}-${data?.maquan}-${
        data?.nam
      }</span></p>
<p><span>Ngày nhận:&nbsp;</span></p>
<p><span>Người tiếp nhận:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;Chữ ký:&nbsp;</span></p>
<p style="margin-left:0in;"><span style="color:black;font-family:'Times New Roman', Times, serif;">&nbsp;</span></p>
<figure class="table">
  <table>
    <tbody>
      <tr>
        <td>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;</td>
        <td>
          <p style="text-align:center;"><span><strong>Cơ quan tiếp nhận</strong></span></p>
          <p style="text-align:center;"><span>(<i>Ký, đóng dấu, ghi rõ họ tên</i>)</span></p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </td>
      </tr>
    </tbody>
  </table>
</figure>
<p style="margin-left:0in;">&nbsp;</p>
<p style="text-align:center;">
  <span><strong>DÀNH CHO CƠ QUAN QUẢN LÝ CHƯƠNG TRÌNH OCOP CẤP TỈNH</strong></span>
</p>
<p><span>Phiếu số:….&nbsp;-&nbsp;……./PĐK-${data?.matinh}-${data?.maquan}-${
        data?.nam
      }</span></p>
<p><span>Ngày nhận:&nbsp;</span></p>
<p><span>Người tiếp nhận: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Chữ ký:&nbsp;</span></p>
<p><span>&nbsp;</span></p>
<figure class="table">
  <table>
    <tbody>
      <tr>
        <td>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</td>
        <td>
          <p style="text-align:center;"><span><strong>Cơ quan tiếp nhận</strong></span></p>
          <p style="text-align:center;"><span>(<i>Ký, đóng dấu, ghi rõ họ tên</i>)</span></p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </td>
      </tr>
    </tbody>
  </table>
</figure>
<p style="margin-left:0in;">&nbsp;</p>`;
      setPrintContent(body);
    }
  }, [data]);
  const handelClear = () => {
    onClose();
  };
  const handleChangeEditor = (event, editor) => {
    const data = editor.getData();
    setPrintContent(data);
  };

  const handlePrint = () => {
    const editorData = printContent;
    const printWindow = window.open("", "");
    printWindow.document.write("<html><head><title>Phiếu đăng ký</title>");
    printWindow.document.write(
      "<style>@page { size: A4; margin: 20mm 12mm 20mm 12mm; } body { font-family: 'Times New Roman', Times, serif, Arial, sans-serif; } li{margin:16px 0;} .table{display:flex; justify-content:flex-end;}</style>"
    );
    printWindow.document.write("</head><body>");
    printWindow.document.write(editorData);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };
  // console.log(printContent);
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "40rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          In đăng ký sản phẩm OCOP
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ overflow: "auto" }}>
          <div className="bg-white">
            <div ref={toolBarRef} />
            <CKEditor
              editor={DecoupledEditor}
              data={printContent ? printContent : ""}
              onReady={(editor) => {
                if (toolBarRef.current) {
                  toolBarRef.current.appendChild(
                    editor.ui.view.toolbar.element
                  );
                }
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "450px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
              onChange={handleChangeEditor}
              config={{
                fontFamily: "Times new roman",
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            startIcon={<PrintIcon />}
            size="small"
            onClick={handlePrint}
            sx={{
              color: "#ffffff",
              float: "right",
              mr: 1,
              backgroundColor: "red",
              ":hover": {
                backgroundColor: "red",
              },
            }}
          >
            In
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{
              color: "#ffffff",
              float: "right",
              mr: 1,
              backgroundColor: "gray",
              ":hover": {
                backgroundColor: "gray",
              },
            }}
          >
            Đóng
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default PrintDangKySanPham;
